(() => {

  if (window.__HYPER_PERSONAL_FEED_BOOTED__) return;

  window.__HYPER_PERSONAL_FEED_BOOTED__ = true;



  /* ══ CONSTANTS ══ */

  var STORAGE_KEY = 'hyper_personal_feed_v3';

  var RECO_CACHE_PREFIX = 'hyper_personal_reco_';

  var VIEW_SESSION_PREFIX = 'hyper_personal_view_';

  var ID_CACHE_PREFIX = 'hyper_pid_';

  var CARD_CACHE_PREFIX = 'hyper_card_-vibe';

  var DWELL_KEY = 'hyper_dwell_data'; /* FIX: now stores {handle, start} */

  var CARD_SECTION = 'personalized-feed-card';



  var DECAY_RATE = 0.05;

  var PROFILE_TTL_DAYS = 60;

  var W_ATC = 5;

  var W_VIEW = 4;       /* weight for product page view */

  var W_FEED_CLICK = 1; /* weight for clicking a link (not viewing page) */

  var MAX_SHOWS_TOP = 3; var MAX_SHOWS_MID = 5; var MAX_SHOWS_LOW = 8;

  var COOLDOWN_BASE = 7;

  var COOLDOWN_MULT = [1, 2, 4.3, 8.6, 12.9];

  var RECYCLE_PEN = [1, 0.70, 0.50, 0.35, 0.20];

  var POOL_WARNING = 0.4; var POOL_CRITICAL = 0.2; var POOL_EMERGENCY = 0.1;

  var SCORE_JITTER = 0.12; var DIVERSITY_CAP = 0.3;

  var SALE_THRESHOLD = 0.5; var RECO_TTL_H = 6;

  var KINSHIP_BOOST = 5; var CLUSTER_BOOST = 7;

  var MAX_BUCKET = 80; var MAX_STATUSES = 300;



  /* Phase 1: Entry signals */

  var COLD_START_MULTIPLIER = 3;  /* First clicks of new user get ×3 weight */

  var UTM_BOOST = 15;             /* Boost for products matching UTM campaign */

  var SEARCH_BOOST = 20;          /* Boost for products matching search query */

  var CART_RETARGET_BOOST = 25;   /* Boost for abandoned cart items */

  var REFERRER_KEY = 'hyper_referrer';

  var UTM_KEY = 'hyper_utm';

  var SEARCH_KEY = 'hyper_searches';



  var memoryProfile = null; var saveTimer = null;

  var renderedImpressions = new Set(); var scrollState = new WeakMap();

  var _genderCache = null; var _genderCacheTime = 0;



  /* ══ UTIL ══ */

  function now() { return Date.now(); }

  function daysAgo(ts) { return Math.max(0, (now() - (ts || now())) / 86400000); }

  function safeJSON(v, fb) { try { return JSON.parse(v); } catch (_) { return fb; } }

  function sGet(s, k) { try { var v = s.getItem(k); return v == null ? null : v; } catch (_) { return null; } }

  function sSet(s, k, v) { try { s.setItem(k, v); } catch (_) {} }

  function normKey(k) { return String(k || '').trim().toLowerCase(); }

  function jitter(s) { return s * (1 + (Math.random() * 2 - 1) * SCORE_JITTER); }

  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  function median(arr) { if (!arr.length) return 0; var s = arr.slice().sort(function (a, b) { return a - b; }); var m = Math.floor(s.length / 2); return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2; }

  function decay(ts) { return Math.exp(-DECAY_RATE * daysAgo(ts)); }



  var isOurReinit = false;

  function reinitSection(sec) {

    setTimeout(function () {

      try { isOurReinit = true; (sec.closest('.shopify-section') || sec).dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sec.dataset.sectionId || '' } })); } catch (_) {}

      setTimeout(function () { isOurReinit = false; }, 200);

    }, 50);

  }



  /* ══ COLLECTION KINSHIP MAP ══ */

  var KINSHIP_FAMILIES = {

    beauty: ['hair-care', 'personal-care-electronics', 'skin-care-hydrate-renew', 'oral-care-products', 'oral-care-electronics', 'bathing-accessories-spa-like-comfort', 'massage-tools', 'electric-massagers', 'health-wellness-monitors', 'personal-care-products'],

    home_kitchen: ['home-decor-products', 'bedding-1', 'kitchen-utensils-supplies', 'kitchen-storage-organization', 'bath', 'storage-home-organization', 'rugs-mats', 'dining-entertaining', 'blankets-throws', 'cookware', 'bakeware', 'glassware-drinkware', 'coffee-tea-espresso', 'kitchen-table-linens', 'cleaning-supplies', 'small-appliances-accessories', 'towels-shower-curtains'],

    home_decor: ['home-decor-products', 'seasonal-decor', 'couch-sofa-decor', 'wall-art', 'lights-lighting-accessories', 'window-treatments-hardware', 'rugs-mats'],

    women_fashion: ['womens-dresses', 'womens-blouses-shirts', 'womens-coats-jackets', 'womens-pants', 'womens-skirts', 'womens-sweaters', 'womens-t-shirts', 'womens-jeans', 'womens-jumpsuits', 'womens-sweatshirts', 'womens-tank-tops-camis', 'womens-two-piece-sets', 'womens-shorts', 'womens-athleisure', 'womens-blazers', 'womens-loungewear'],

    women_accessories: ['womens-jewelry', 'womens-watches', 'hair-accessories', 'womens-hats-caps', 'womens-wraps-scarves', 'womens-belts', 'womens-eyewear', 'womens-keyrings-accessories'],

    women_shoes: ['womens-fashion-sneakers', 'womens-ankle-boots-booties', 'womens-pumps', 'womens-heeled-sandals', 'womens-flat-sandals', 'womens-loafers-slip-ons', 'womens-knee-high-boots', 'womens-flats', 'womens-slide-sandals', 'womens-mules-clogs'],

    women_lingerie: ['womens-bras-bralettes', 'womens-panties', 'womens-sleepwear', 'womens-shapewear', 'womens-sexy-lingerie', 'womens-lingerie-set'],

    women_swim: ['womens-bikini-sets-1', 'womens-one-pieces', 'womens-cover-ups', 'womens-tankinis', 'womens-beachwear-sets'],

    men_fashion: ['mens-cargo-pants', 'mens-casual-dress-shirts', 'mens-casual-pants', 'mens-hoodies-sweatshirts', 'mens-jackets-coats', 'mens-jeans', 'mens-t-shirts', 'mens-suits-separates', 'mens-sweaters', 'mens-shorts', 'mens-tops', 'mens-polos', 'mens-sets'],

    men_shoes: ['mens-casual-shoes', 'mens-semi-formal-shoes', 'mens-loafers-slip-ons', 'mens-boots', 'mens-slippers', 'mens-snow-boots'],

    kids: ['girls-sets', 'boys-sets', 'baby-sets', 'kids-underwear-socks', 'girls-tops', 'boys-tops', 'girls-pants', 'girls-dresses', 'baby-one-pieces', 'boys-pants', 'kids-bags', 'kids-backpacks'],

    kids_shoes: ['boys-sneakers', 'girls-boots', 'girls-sneakers', 'boys-athletic', 'girls-athletic', 'baby-girl-shoes', 'baby-boy-shoes'],

    tech_tools: ['surveillance-cameras', 'led-strip-lights', 'flashlights', 'power-tools', 'hand-tools-everyday-fixes', 'electrical', 'lighting-ceiling-fans', 'hardware'],

    gaming: ['gaming-controllers', 'gaming-consoles', 'gaming-accessories', 'gaming-headsets', 'gaming-mice', 'gaming-keyboards', 'gaming-chairs', 'video-games', 'gaming', 'controllers', 'consoles', 'pc-gaming', 'game-accessories', 'playstation', 'xbox', 'nintendo'],

    electronics: ['electronics', 'headphones', 'speakers', 'phone-accessories', 'smart-home', 'tablets', 'laptops', 'cameras', 'wearables', 'chargers-cables', 'surveillance-cameras', 'led-strip-lights'],

    sports: ['exercise-fitness-items', 'camping-hiking', 'yoga-fitness-mats', 'swimming-diving-water-sports', 'cycling', 'sports-outdoor-accessories', 'sports-electronics-gadgets', 'climbing-survival-tools'],

    sports_wear: ['mens-activewear', 'womens-activewear', 'mens-sports-outdoor-shoes', 'womens-athletic-shoes'],

    garden: ['pest-control', 'outdoor-lighting', 'planters-containers', 'outdoor-decor', 'watering-irrigation', 'gardening-tools', 'garden-sculptures', 'plants-seeds-bulbs']

  };



  var _collToFamilies = {};

  Object.keys(KINSHIP_FAMILIES).forEach(function (fam) {

    KINSHIP_FAMILIES[fam].forEach(function (col) {

      if (!_collToFamilies[col]) _collToFamilies[col] = [];

      _collToFamilies[col].push(fam);

    });

  });



  function getProductFamilies(product) {

    var cols = product.source_collections || product.collections || [];

    var fams = new Set();

    cols.forEach(function (c) { (_collToFamilies[normKey(c)] || []).forEach(function (f) { fams.add(f); }); });

    return fams;

  }



  function getUserFamilies(pr) {

    var fams = {};

    Object.entries(pr.collections || {}).forEach(function (pair) {

      var data = pair[1]; if (!data || !data.score) return;

      var w = data.score * decay(data.lastSeen);

      (_collToFamilies[pair[0]] || []).forEach(function (f) { fams[f] = (fams[f] || 0) + w; });

    });

    return fams;

  }



  function getClusterTags(tags) {

    var c = [];

    (tags || []).forEach(function (t) { var s = String(t).trim().toLowerCase(); if (s.indexOf('cluster:') === 0) c.push(s.substring(8)); });

    return c;

  }



  /** Generic: extract tags by prefix. getTagsByPrefix(tags, 'demo:') → ['female','teen'] */

  function getTagsByPrefix(tags, prefix) {

    var c = [];

    (tags || []).forEach(function (t) { var s = String(t).trim().toLowerCase(); if (s.indexOf(prefix) === 0) c.push(s.substring(prefix.length)); });

    return c;

  }



  function getUserClusters(pr) {

    var clusters = {};

    Object.values(pr.products || {}).forEach(function (p) {

      if (!p || !p.tags || !p.score) return;

      var w = p.score * decay(p.lastSeen);

      getClusterTags(p.tags).forEach(function (c) { clusters[c] = (clusters[c] || 0) + w; });

    });

    return clusters;

  }



  /** Build user profile from any prefixed tags (demo:, persona:, intent:) */

  function getUserTagProfile(pr, prefix) {

    var profile = {};

    Object.values(pr.products || {}).forEach(function (p) {

      if (!p || !p.tags || !p.score) return;

      var w = p.score * decay(p.lastSeen);

      getTagsByPrefix(p.tags, prefix).forEach(function (t) { profile[t] = (profile[t] || 0) + w; });

    });

    return profile;

  }



  /* ══ PROFILE ══

     Now includes `categories` bucket for Shopify taxonomy.

  */

  function defaultProfile() {

    return {

      updatedAt: now(), products: {}, tags: {}, types: {},

      collections: {}, categories: {}, statuses: {},

      priceClicks: [], saleClicks: 0, totalClicks: 0,

      /* Session: resets after 30min inactivity */

      session: { lastActive: 0, cats: {}, types: {}, families: {}, clicks: 0 },

      /* Wave: top categories from last 5 sessions, for interest rotation */

      recentSessions: []  /* [{date, topCats: ["Hair Care","Shoes"], clicks: 8}, ...] */

    };

  }



  function loadProfile() {

    if (memoryProfile) return memoryProfile;

    var raw = sGet(localStorage, STORAGE_KEY);

    var p = raw ? safeJSON(raw, null) : null;

    p = p && typeof p === 'object' ? p : defaultProfile();

    memoryProfile = {

      updatedAt: p.updatedAt || now(), products: p.products || {}, tags: p.tags || {},

      types: p.types || {}, collections: p.collections || {},

      categories: p.categories || {}, statuses: p.statuses || {},

      priceClicks: Array.isArray(p.priceClicks) ? p.priceClicks : [],

      saleClicks: p.saleClicks || 0, totalClicks: p.totalClicks || 0,

      session: p.session || { lastActive: 0, cats: {}, types: {}, families: {}, clicks: 0 },

      recentSessions: Array.isArray(p.recentSessions) ? p.recentSessions.slice(-5) : []

    };

    /* Detect new session: >30 min since last activity */

    checkSessionReset(memoryProfile);

    pruneProfile(memoryProfile);

    return memoryProfile;

  }



  var SESSION_GAP_MS = 30 * 60 * 1000; /* 30 min = new session */



  /**

   * Session management: detect new session, archive old one for wave patterns.

   * Called on every loadProfile.

   */

  function checkSessionReset(pr) {

    var sess = pr.session;

    if (!sess || !sess.lastActive) {

      pr.session = { lastActive: now(), cats: {}, types: {}, families: {}, clicks: 0 };

      return;

    }

    /* If >30 min since last activity → new session */

    if (now() - sess.lastActive > SESSION_GAP_MS && sess.clicks > 0) {

      /* Archive old session for wave detection.

         Use cats first, fall back to types if cats empty. */

      var source = Object.keys(sess.cats || {}).length > 0 ? sess.cats :

                   Object.keys(sess.types || {}).length > 0 ? sess.types : {};

      var topCats = Object.entries(source)

        .sort(function (a, b) { return b[1] - a[1]; })

        .slice(0, 3)

        .map(function (e) { return e[0]; });



      /* Always archive if session had clicks, even without category data */

      pr.recentSessions.push({

        date: sess.lastActive,

        topCats: topCats,

        clicks: sess.clicks

      });

      if (pr.recentSessions.length > 5) pr.recentSessions = pr.recentSessions.slice(-5);



      /* Reset current session */

      pr.session = { lastActive: now(), cats: {}, types: {}, families: {}, clicks: 0 };

    }

  }



  /**

   * Record session activity: track type, category, AND kinship families.

   * This is the key fix: if user clicks Joystick (type: Controllers, family: gaming)

   * and then Console (type: Consoles, family: gaming), the "gaming" family

   * accumulates 2 clicks even though types are different.

   */

  function sessionRecord(pr, type, category, collections) {

    var sess = pr.session;

    sess.lastActive = now();

    sess.clicks = (sess.clicks || 0) + 1;

    if (!sess.families) sess.families = {};



    if (type) {

      var tk = normKey(type);

      sess.types[tk] = (sess.types[tk] || 0) + 1;

    }

    if (category) {

      var parts = String(category).split('>');

      var leaf = normKey((parts[parts.length - 1] || '').trim());

      if (leaf) sess.cats[leaf] = (sess.cats[leaf] || 0) + 1;

      if (parts.length >= 2) {

        var mid = normKey((parts[1] || '').trim());

        if (mid) sess.cats[mid] = (sess.cats[mid] || 0) + 0.5;

      }

    }

    /* Track kinship families from collections */

    (collections || []).forEach(function (c) {

      (_collToFamilies[normKey(c)] || []).forEach(function (fam) {

        sess.families[fam] = (sess.families[fam] || 0) + 1;

      });

    });

  }



  /**

   * Get session momentum. Now checks 3 layers:

   * 1. Exact type match (strongest: same type clicked)

   * 2. Kinship family match (medium: different type but same family)

   * 3. Category hierarchy match (broader)

   *

   * Example: user clicked Joystick (gaming family) + Console (gaming family)

   * → type momentum: 1 each (weak)

   * → family momentum: 2 (gaming) → +15 boost!

   * → any other gaming product benefits even with a different type

   */

  function getSessionMomentum(pr, product) {

    var sess = pr.session;

    if (!sess || sess.clicks === 0) return 0;



    var boost = 0;



    /* Layer 1: Exact type match */

    var tk = normKey(product.type || '');

    if (tk && sess.types[tk]) {

      var count = sess.types[tk];

      if (count >= 3) boost += 25;

      else if (count >= 2) boost += 12;

      else boost += 4;

    }



    /* Layer 2: Kinship family match (THE KEY FIX)

       Joystick (gaming) + Console (gaming) = family "gaming" has 2 clicks

       → Mouse (gaming) gets +15 even though type "Mice" has 0 clicks */

    if (sess.families) {

      var productFams = getProductFamilies(product);

      var bestFamBoost = 0;

      productFams.forEach(function (fam) {

        if (sess.families[fam]) {

          var famCount = sess.families[fam];

          var fb = 0;

          if (famCount >= 4) fb = 25;

          else if (famCount >= 3) fb = 18;

          else if (famCount >= 2) fb = 12;

          else fb = 5;

          if (fb > bestFamBoost) bestFamBoost = fb;

        }

      });

      /* Don't double-count if type already gave a boost */

      if (bestFamBoost > boost) boost = bestFamBoost;

    }



    /* Layer 3: Category hierarchy */

    if (product.category) {

      var parts = String(product.category).split('>');

      var leaf = normKey((parts[parts.length - 1] || '').trim());

      if (leaf && sess.cats[leaf]) {

        var catCount = sess.cats[leaf];

        var catBoost = 0;

        if (catCount >= 3) catBoost = 15;

        else if (catCount >= 2) catBoost = 8;

        else catBoost = 3;

        boost += catBoost;

      }

      if (parts.length >= 2) {

        var mid = normKey((parts[1] || '').trim());

        if (mid && sess.cats[mid] && !sess.cats[leaf]) {

          boost += Math.min(10, sess.cats[mid] * 3);

        }

      }

    }



    return boost;

  }



  /**

   * Interest wave: penalize categories that dominated recent sessions,

   * boost categories user hasn't seen recently.

   */

  function getWaveBoost(pr, product) {

    var recent = pr.recentSessions;

    if (!recent || recent.length < 2) return 0;



    var tk = normKey(product.type || '');

    if (!tk) return 0;



    /* Count how many of last 5 sessions this type was dominant */

    var dominated = 0;

    var appeared = 0;

    recent.forEach(function (sess) {

      (sess.topCats || []).forEach(function (cat) {

        if (normKey(cat) === tk) { appeared++; if (sess.topCats[0] === cat) dominated++; }

      });

    });



    /* Category dominated 3+ of last 5 sessions → slight fatigue penalty */

    if (dominated >= 3) return -5;

    if (dominated >= 2) return -2;



    /* Category never appeared in recent sessions → fresh interest boost */

    if (appeared === 0 && recent.length >= 3) return 6;



    return 0;

  }



  function saveNow() { clearTimeout(saveTimer); if (!memoryProfile) return; memoryProfile.updatedAt = now(); sSet(localStorage, STORAGE_KEY, JSON.stringify(memoryProfile)); }

  function saveLater() { clearTimeout(saveTimer); saveTimer = setTimeout(saveNow, 200); }



  function pruneBucket(b) {

    var min = now() - PROFILE_TTL_DAYS * 86400000;

    return Object.fromEntries(Object.entries(b || {}).filter(function (p) { return p[1] && (p[1].lastSeen || 0) >= min; }).sort(function (a, b) { return (b[1].score || 0) - (a[1].score || 0) || (b[1].lastSeen || 0) - (a[1].lastSeen || 0); }).slice(0, MAX_BUCKET));

  }



  function pruneProfile(p) {

    p.products = pruneBucket(p.products); p.tags = pruneBucket(p.tags);

    p.types = pruneBucket(p.types); p.collections = pruneBucket(p.collections);

    p.categories = pruneBucket(p.categories);

    var min = now() - 90 * 86400000;

    p.statuses = Object.fromEntries(Object.entries(p.statuses || {}).filter(function (x) { return x[1] && ((x[1].lastShown || 0) >= min || (x[1].lastClicked || 0) >= min); }).slice(0, MAX_STATUSES));

    p.priceClicks = (p.priceClicks || []).slice(-50);

    return p;

  }



  /* ══ STATUS MACHINE ══ */

  function getSt(handle, pr) {

    var k = normKey(handle);

    if (!pr.statuses[k]) pr.statuses[k] = { st: 'fresh', shows: 0, clicks: 0, lastShown: 0, lastClicked: 0, firstShown: 0, coolUntil: 0, recycles: 0, pos: 99 };

    return pr.statuses[k];

  }



  function statusShow(handle, pr, position) {

    var s = getSt(handle, pr);

    if (s.st === 'fresh') { s.st = 'shown'; s.firstShown = now(); }

    s.shows++; s.lastShown = now(); s.pos = position || 99;

    if (s.clicks === 0) {

      var maxS = s.pos <= 5 ? MAX_SHOWS_TOP : s.pos <= 20 ? MAX_SHOWS_MID : MAX_SHOWS_LOW;

      if (s.shows >= maxS) {

        s.st = 'cooling';

        s.coolUntil = now() + COOLDOWN_BASE * (COOLDOWN_MULT[Math.min(s.recycles, 4)] || 1) * 86400000;

      }

    }

  }



  /**

   * FIX: statusClick is ONLY called from trackView (product page load).

   * dwellMs is time spent on THIS product (measured when user LEAVES).

   */

  function statusClick(handle, pr, dwellMs) {

    var s = getSt(handle, pr);

    s.clicks++; s.lastClicked = now();

    if (dwellMs && dwellMs < 3000) { /* bounce: don't upgrade status */ }

    else if (dwellMs && dwellMs > 15000) s.st = 'engaged';

    else s.st = 'clicked';

    if (s.coolUntil > 0) { s.coolUntil = 0; }

  }



  function statusCart(handle, pr) {

    var s = getSt(handle, pr); s.st = 'carted'; s.lastClicked = now(); s.coolUntil = 0;

  }



  function isAvailable(handle, pr) {

    var s = getSt(handle, pr);

    if (s.st === 'purchased') return false;

    if (s.st === 'cooling' && s.coolUntil > now()) return false;

    if (s.st === 'cooling' && s.coolUntil <= now()) { s.st = 'recycled'; s.shows = 0; s.recycles++; }

    if (s.recycles >= 5 && s.clicks === 0) return false;

    return true;

  }



  function recyclePenalty(handle, pr) {

    return RECYCLE_PEN[Math.min(getSt(handle, pr).recycles, 4)] || 1;

  }



  /* ══ POOL HEALTH ══ */

  function poolHealth(total, pr) {

    var cooling = 0;

    Object.values(pr.statuses || {}).forEach(function (s) { if (s.st === 'cooling' && s.coolUntil > now()) cooling++; });

    return total > 0 ? Math.max(0, total - cooling) / total : 1;

  }

  function softLevel(h) { if (h >= POOL_WARNING) return 0; if (h >= POOL_CRITICAL) return 1; if (h >= POOL_EMERGENCY) return 2; return 3; }



  /* ══ SIGNALS ══ */

  function touchBucket(bkt, key, w, ex) {

    var k = normKey(key); if (!k) return;

    if (!bkt[k]) bkt[k] = { score: 0, lastSeen: 0 };

    bkt[k].score += w; bkt[k].lastSeen = now();

    if (ex) Object.keys(ex).forEach(function (f) { var v = ex[f]; if (v != null && v !== '') bkt[k][f] = v; });

  }



  function getCollCtx() {

    var m = location.pathname.match(/^\/collections\/([^/]+)/);

    if (m && m[1]) {

      /* On a collection page — store for next product page */

      sSet(sessionStorage, 'hyper_ref_collection', m[1]);

      return [m[1]];

    }

    /* On product page — read stored collection from where user came */

    var stored = sGet(sessionStorage, 'hyper_ref_collection');

    return stored ? [stored] : [];

  }



  /**

   * addSignal: ONLY updates affinity buckets. NO status machine.

   * Now also records Shopify taxonomy category.

   */

  function addSignal(prod, weight) {

    var cols = Array.isArray(prod.collections) && prod.collections.length ? prod.collections : Array.isArray(prod.source_collections) && prod.source_collections.length ? prod.source_collections : [];

    var h = prod.handle || ''; if (!h) return;

    var pr = loadProfile(); var k = normKey(h);



    /* Phase 1: Cold Start Amplifier.

       First 3 clicks of a new user get ×3 weight.

       This makes the feed adapt after a single click instead of 3. */

    var productCount = Object.keys(pr.products || {}).length;

    if (productCount < 3) weight *= COLD_START_MULTIPLIER;



    var existing = pr.products[k];

    var vc = (existing && existing.viewCount) ? existing.viewCount + 1 : 1;



    touchBucket(pr.products, h, weight, {

      id: prod.id || null, handle: h, title: prod.title || '', url: prod.url || '',

      image: prod.featured_image || prod.image || '',

      type: prod.type || '', tags: Array.isArray(prod.tags) ? prod.tags : [],

      viewCount: vc, category: prod.category || ''

    });

    if (prod.type) touchBucket(pr.types, prod.type, weight * 0.8);

    (Array.isArray(prod.tags) ? prod.tags : []).slice(0, 20).forEach(function (t) { touchBucket(pr.tags, t, weight * 0.45); });

    cols.slice(0, 10).forEach(function (c) { touchBucket(pr.collections, c, weight * 0.9); });



    /* Shopify taxonomy: split "Health & Beauty > Personal Care > Hair Care"

       into 3 levels and store each with decreasing weight.

       Parent categories get weaker signal, leaf gets strongest. */

    if (prod.category) {

      var parts = String(prod.category).split('>').map(function (s) { return s.trim(); }).filter(Boolean);

      var path = '';

      for (var ci = 0; ci < parts.length; ci++) {

        path = path ? path + ' > ' + parts[ci] : parts[ci];

        /* Leaf gets full weight, each parent level gets 60% of child */

        var catWeight = weight * Math.pow(0.6, parts.length - 1 - ci);

        touchBucket(pr.categories, path, catWeight);

      }

    }



    /* Price + sale */

    var price = parseFloat(prod.price) || 0;

    if (price > 0) { pr.priceClicks.push(price); if (pr.priceClicks.length > 50) pr.priceClicks = pr.priceClicks.slice(-50); }

    pr.totalClicks = (pr.totalClicks || 0) + 1;

    var cmp = parseFloat(prod.compare_at_price) || 0;

    if (cmp > 0 && cmp > price) pr.saleClicks = (pr.saleClicks || 0) + 1;



    /* Session momentum tracking — pass collections for kinship family detection */

    sessionRecord(pr, prod.type, prod.category, cols);



    pruneProfile(pr); saveLater();

  }



  function markImpressions(handles, startPos) {

    var pr = loadProfile();

    handles.forEach(function (h, idx) {

      var k = normKey(h);

      if (!k || renderedImpressions.has(k)) return;

      renderedImpressions.add(k);

      statusShow(k, pr, (startPos || 1) + idx);

    });

    pruneProfile(pr); saveLater();

  }



  /* ══ DWELL TIME ══

     FIX: stores product handle WITH the timer.

     endDwell returns {handle, ms} for the PREVIOUS product.

     Applied to the CORRECT product.

  */

  function startDwell(handle) {

    if (!handle) return;

    sSet(sessionStorage, DWELL_KEY, JSON.stringify({ handle: normKey(handle), start: now() }));

  }



  function endDwell() {

    var raw = sGet(sessionStorage, DWELL_KEY);

    if (!raw) return null;

    var data = safeJSON(raw, null);

    if (!data || !data.handle || !data.start) return null;

    try { sessionStorage.removeItem(DWELL_KEY); } catch (_) {}

    return { handle: data.handle, ms: now() - data.start };

  }



  /* ══ SCORING ══ */

  /* ══ PHASE 1: ENTRY SIGNALS ══ */



  /**

   * Parse UTM params from URL on first visit.

   * ?utm_campaign=gaming&utm_content=retro → { campaign: 'gaming', content: 'retro' }

   * Stored in sessionStorage so it persists across pages.

   */

  function parseUTM() {

    var stored = sGet(sessionStorage, UTM_KEY);

    if (stored) return safeJSON(stored, null);

    try {

      var params = new URLSearchParams(location.search || '');

      var utm = {};

      ['utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term'].forEach(function (k) {

        var v = params.get(k); if (v) utm[k.replace('utm_', '')] = normKey(v);

      });

      if (Object.keys(utm).length > 0) {

        sSet(sessionStorage, UTM_KEY, JSON.stringify(utm));

        return utm;

      }

    } catch (_) {}

    return null;

  }



  /**

   * Detect referrer source category.

   * Pinterest → visual/decor, Reddit → tech/geek, Instagram → trend/fashion

   */

  function parseReferrer() {

    var stored = sGet(sessionStorage, REFERRER_KEY);

    if (stored) return stored;

    try {

      var ref = (document.referrer || '').toLowerCase();

      var source = 'direct';

      if (ref.indexOf('pinterest') >= 0) source = 'visual';

      else if (ref.indexOf('reddit') >= 0) source = 'tech';

      else if (ref.indexOf('instagram') >= 0 || ref.indexOf('tiktok') >= 0) source = 'trend';

      else if (ref.indexOf('facebook') >= 0) source = 'social';

      else if (ref.indexOf('google') >= 0 || ref.indexOf('bing') >= 0) source = 'search';

      else if (ref.indexOf('youtube') >= 0) source = 'video';

      if (source !== 'direct') sSet(sessionStorage, REFERRER_KEY, source);

      return source;

    } catch (_) { return 'direct'; }

  }



  /**

   * Track on-site search queries.

   * Intercepts Shopify search form + predictive search.

   */

  function trackSearch() {

    function recordQuery(q) {

      if (!q || q.length < 2) return;

      var queries = safeJSON(sGet(sessionStorage, SEARCH_KEY), []) || [];

      queries.push({ q: normKey(q), t: now() });

      if (queries.length > 10) queries = queries.slice(-10);

      sSet(sessionStorage, SEARCH_KEY, JSON.stringify(queries));

    }



    /* Intercept search form submissions */

    document.addEventListener('submit', function (e) {

      if (!(e.target instanceof HTMLFormElement)) return;

      var action = e.target.getAttribute('action') || '';

      if (action.indexOf('/search') === -1) return;

      var input = e.target.querySelector('input[name="q"]');

      if (input && input.value) recordQuery(input.value);

    }, true);



    /* Intercept URL-based search */

    try {

      var params = new URLSearchParams(location.search || '');

      var q = params.get('q');

      if (q && location.pathname.indexOf('/search') >= 0) recordQuery(q);

    } catch (_) {}

  }



  function getRecentSearches() {

    return safeJSON(sGet(sessionStorage, SEARCH_KEY), []) || [];

  }



  /**

   * Time-of-day context scoring.

   * Morning (6-11): practical, essentials

   * Afternoon (12-17): browsing, comparison

   * Evening (18-23): impulse, gift, treat-yourself

   * Night (0-5): deep interest, long sessions

   */

  function getTimeOfDayBoost(product) {

    var hour = new Date().getHours();

    var intents = getTagsByPrefix(product.tags || [], 'intent:');

    var boost = 0;



    if (hour >= 6 && hour < 12) {

      /* Morning: practical, essentials */

      if (intents.indexOf('essentials') >= 0) boost += 3;

      if (intents.indexOf('problem-solver') >= 0) boost += 3;

      if (intents.indexOf('impulse') >= 0) boost -= 1;

    } else if (hour >= 18 || hour < 2) {

      /* Evening/night: impulse, gift, treat-yourself */

      if (intents.indexOf('impulse') >= 0) boost += 3;

      if (intents.indexOf('gift') >= 0) boost += 3;

      if (intents.indexOf('treat-yourself') >= 0) boost += 3;

      if (intents.indexOf('trending') >= 0) boost += 2;

    }



    /* Weekend boost for hobbies */

    var day = new Date().getDay();

    if (day === 0 || day === 6) {

      var personas = getTagsByPrefix(product.tags || [], 'persona:');

      if (personas.indexOf('homebody') >= 0 || personas.indexOf('creative') >= 0 ||

          personas.indexOf('gamer') >= 0 || personas.indexOf('foodie') >= 0) boost += 2;

    }



    return boost;

  }



  /**

   * UTM matching: does product match the campaign the user came from?

   */

  function getUTMBoost(product, utm) {

    if (!utm) return 0;

    var boost = 0;

    var haystack = [product.handle || '', product.type || '', (product.tags || []).join(' '),

      (product.source_collections || product.collections || []).join(' '),

      product.category || ''].join(' ').toLowerCase();



    /* Match campaign keywords against product data */

    ['campaign', 'content', 'term'].forEach(function (field) {

      if (!utm[field]) return;

      var keywords = utm[field].split(/[-_+\s]+/);

      keywords.forEach(function (kw) {

        if (kw.length >= 3 && haystack.indexOf(kw) >= 0) boost += UTM_BOOST;

      });

    });



    return Math.min(boost, UTM_BOOST * 2); /* Cap at 2× UTM_BOOST */

  }



  /**

   * Search query matching: does product match what user searched for?

   */

  function getSearchBoost(product, searches) {

    if (!searches || !searches.length) return 0;

    var haystack = [product.handle || '', product.title || '', product.type || '',

      (product.tags || []).join(' ')].join(' ').toLowerCase();

    var boost = 0;



    /* Check recent searches (more recent = stronger) */

    searches.forEach(function (search, idx) {

      var recency = (idx + 1) / searches.length; /* 0→1, most recent = 1 */

      var words = (search.q || '').split(/\s+/);

      words.forEach(function (w) {

        if (w.length >= 3 && haystack.indexOf(w) >= 0) {

          boost += SEARCH_BOOST * recency;

        }

      });

    });



    return Math.min(boost, SEARCH_BOOST * 2);

  }



  /**

   * Cart retargeting: boost products with status 'carted'.

   */

  function getCartRetargetBoost(handle, pr) {

    var st = getSt(handle, pr);

    if (st.st === 'carted') return CART_RETARGET_BOOST;

    /* Also boost engaged products that were viewed 2+ times (almost-carted) */

    if (st.st === 'engaged' && st.clicks >= 2) return 8;

    return 0;

  }



  /**

   * Referrer-based cold start hints.

   */

  function getReferrerBoost(product, source) {

    if (!source || source === 'direct') return 0;

    var personas = getTagsByPrefix(product.tags || [], 'persona:');

    var intents = getTagsByPrefix(product.tags || [], 'intent:');



    if (source === 'visual' && (personas.indexOf('homebody') >= 0 || personas.indexOf('fashionista') >= 0)) return 4;

    if (source === 'tech' && (personas.indexOf('techie') >= 0 || personas.indexOf('gamer') >= 0)) return 4;

    if (source === 'trend' && intents.indexOf('trending') >= 0) return 5;

    if (source === 'trend' && personas.indexOf('fashionista') >= 0) return 3;

    if (source === 'social' && intents.indexOf('impulse') >= 0) return 3;



    return 0;

  }



  function getMedianPrice(pr) { return median((pr.priceClicks || []).filter(function (p) { return p > 0; })); }

  function getSaleAffinity(pr) { var t = pr.totalClicks || 0; return t < 3 ? 0 : (pr.saleClicks || 0) / t; }



  var GP = {

    female: /\b(women|woman|womens|ladies|girl|girls|feminine|maternity|bra|bralette|bikini|lingerie|her|hers|she)\b/i,

    male: /\b(men|mans|mens|boy|boys|masculine|gentlemen|him|his|guy|guys)\b/i,

    kids: /\b(kids|kid|baby|toddler|infant|child|children|junior)\b/i

  };

  function detectGender(p) {

    /* Priority 1: demo: tags (most reliable — set by merchant) */

    var demos = getTagsByPrefix(p.tags || [], 'demo:');

    if (demos.indexOf('kids') >= 0) return 'kids';

    if (demos.indexOf('female') >= 0) return 'female';

    if (demos.indexOf('male') >= 0) return 'male';

    if (demos.indexOf('unisex') >= 0) return 'neutral';

    /* Priority 2: regex fallback */

    var s = [p.handle || '', p.type || '', (p.tags || []).join(' '), (p.source_collections || p.collections || []).join(' '), p.category || ''].join(' ');

    if (GP.kids.test(s)) return 'kids'; if (GP.female.test(s)) return 'female'; if (GP.male.test(s)) return 'male'; return 'neutral';

  }

  function getUserGender(pr) {

    if (_genderCache && now() - _genderCacheTime < 5000) return _genderCache;

    var c = { female: 0, male: 0, kids: 0, neutral: 0 }; var t = 0;

    Object.values(pr.products || {}).forEach(function (p) {

      if (!p || !p.score || p.score <= 0) return;

      var w = p.score * decay(p.lastSeen);

      c[detectGender(p)] += w; t += w;

    });

    if (t === 0) { _genderCache = { g: 'neutral', c: 0 }; _genderCacheTime = now(); return _genderCache; }

    var top = 'neutral'; var ts = 0;

    ['female', 'male', 'kids'].forEach(function (g) { if (c[g] > ts) { top = g; ts = c[g]; } });

    _genderCache = { g: top, c: ts / t }; _genderCacheTime = now(); return _genderCache;

  }



  function getExploreRatio(pr) {

    var tc = {}; var t = 0;

    Object.values(pr.products || {}).forEach(function (p) { if (!p || !p.type) return; var k = normKey(p.type); tc[k] = (tc[k] || 0) + (p.score || 1); t += (p.score || 1); });

    if (t === 0) return 0.2; var max = 0; Object.values(tc).forEach(function (c) { if (c / t > max) max = c / t; });

    return max > 0.8 ? 0.1 : max < 0.4 ? 0.3 : 0.2;

  }



  function getColdStart(pr) { var n = Object.keys(pr.products || {}).length; if (n === 0) return 0; if (n < 5) return 1; if (n < 15) return 2; if (n < 50) return 3; return 4; }



  /* ── MAIN SCORING ── */

  function scoreProduct(product, pr, ctx) {

    var hk = normKey(product.handle); var tk = normKey(product.type);

    var sl = ctx.sl || 0; var mp = ctx.mp || 0; var cl = ctx.cl || 0;

    var s = 0;



    /* 1. Affinity with decay */

    var pa = pr.products[hk]; if (pa) s += pa.score * 0.5 * decay(pa.lastSeen);

    var ta = pr.types[tk]; if (ta) s += ta.score * 1.2 * decay(ta.lastSeen);

    (product.tags || []).forEach(function (t) { var a = pr.tags[normKey(t)]; if (a) s += a.score * 1.05 * decay(a.lastSeen); });

    (product.source_collections || product.collections || []).forEach(function (c) { var a = pr.collections[normKey(c)]; if (a) s += a.score * 1.1 * decay(a.lastSeen); });



    /* 1b. Shopify taxonomy: check ALL levels of category hierarchy.

       "Health & Beauty > Personal Care > Hair Care" checks:

       - full path (exact match, strongest)

       - "Health & Beauty > Personal Care" (parent, medium)

       - "Health & Beauty" (grandparent, weakest) */

    if (product.category) {

      var catParts = String(product.category).split('>').map(function (x) { return x.trim(); }).filter(Boolean);

      var catPath = '';

      for (var ci = 0; ci < catParts.length; ci++) {

        catPath = catPath ? catPath + ' > ' + catParts[ci] : catParts[ci];

        var ca = pr.categories[normKey(catPath)];

        /* Leaf match = 1.5x, each parent level = 40% less */

        if (ca) s += ca.score * (1.5 * Math.pow(0.6, catParts.length - 1 - ci)) * decay(ca.lastSeen);

      }

    }



    if (product.recommendation_source) s += 8;

    if (product.available === false) s -= 100;



    /* 2. CTR from status machine */

    var st = pr.statuses[hk];

    if (st && st.shows > 0) {

      var ctr = (st.clicks || 0) / st.shows;

      if (ctr > 0) s += ctr * 12;

      else s -= st.shows * 2.0;

    }



    /* 3. Recycle penalty */

    s *= recyclePenalty(hk, pr);



    /* 4. Price */

    if (cl >= 2 && sl < 2 && mp > 0 && product.price > 0) {

      var r = product.price / mp;

      if (r >= 0.7 && r <= 1.3) s += 5;

      else if (r > 2 || r < 0.3) s -= sl >= 1 ? 3 : 8;

      else s -= sl >= 1 ? 1 : 3;

    }



    /* 5. Gender */

    if (cl >= 2 && sl < 2) {

      var ug = getUserGender(pr);

      if (ug.c > 0.4) {

        var pg = detectGender(product);

        if (pg !== 'neutral' && ug.g !== 'neutral') {

          if (pg === ug.g) s += 6; else s -= (sl >= 1 ? 8 : 20) * ug.c;

        }

      }

    }



    /* 6. Sale affinity */

    var sa = getSaleAffinity(pr);

    var onSale = product.compare_at_price && product.compare_at_price > (product.price || 0);

    if (sa >= SALE_THRESHOLD) { s += onSale ? 7 : -2; }

    else if (sa > 0 && sa < 0.2 && !onSale) s += 2;



    /* 7. Newness */

    if (product.created_at) {

      var age = daysAgo(new Date(product.created_at).getTime());

      if (age < 3) s += 6; else if (age < 7) s += 4; else if (age < 14) s += 2;

    }



    /* 8. Session momentum: adapts in real-time within a session.

       1 click in category = +4, 2 clicks = +12, 3+ clicks = +25+.

       This means: user clicks 3 toys → toys get +40 boost. */

    var momentum = getSessionMomentum(pr, product);

    s += momentum;



    /* 8b. Interest wave: rotate interests across sessions. */

    s += getWaveBoost(pr, product);



    /* 8c. Session blend: when user shows clear new intent (3+ clicks),

       dampen ALL historical affinity so new interest can surface.

       Without this, 15 old dress views (~330 pts) would always beat

       3 toy clicks (~40 pts). With blend, dress score drops to ~130,

       letting toys compete.

       

       Formula: effective_history = history × (1 - sessionFocus)

       sessionFocus = 0 (no session) to 0.7 (strong new intent) */

    if (pr.session && pr.session.clicks >= 3 && momentum === 0) {

      /* User is actively clicking OTHER categories → dampen this product's historical score */

      var sessionFocus = Math.min(0.7, pr.session.clicks * 0.08);

      s *= (1 - sessionFocus);

    }



    /* 9. Repeat view boost */

    if (pa && pa.viewCount >= 2) s += 3;



    /* 10. Collection kinship */

    if (ctx.userFamilies) {

      getProductFamilies(product).forEach(function (fam) {

        if (ctx.userFamilies[fam]) s += KINSHIP_BOOST * Math.min(1, ctx.userFamilies[fam] / 10);

      });

    }



    /* 11. Cluster tags */

    if (ctx.userClusters && product.tags) {

      getClusterTags(product.tags).forEach(function (cluster) {

        if (ctx.userClusters[cluster]) s += CLUSTER_BOOST * Math.min(1, ctx.userClusters[cluster] / 5);

      });

    }



    /* 12. Persona matching: user who clicks persona:gamer items

       will see other persona:gamer items boosted.

       This connects gaming keyboard → gaming chair → energy drink mug

       even if they have no cluster/kinship/category in common. */

    if (ctx.userPersonas && product.tags) {

      getTagsByPrefix(product.tags, 'persona:').forEach(function (p) {

        if (ctx.userPersonas[p]) s += 6 * Math.min(1, ctx.userPersonas[p] / 8);

      });

    }



    /* 13. Intent matching: user who clicks intent:impulse items

       sees more impulse items. User who clicks intent:gift

       sees more gift-appropriate items. */

    if (ctx.userIntents && product.tags) {

      getTagsByPrefix(product.tags, 'intent:').forEach(function (i) {

        if (ctx.userIntents[i]) s += 4 * Math.min(1, ctx.userIntents[i] / 5);

      });

    }



    /* 14. Demo age matching: user who clicks demo:teen items

       sees more demo:teen items, fewer demo:senior.

       Strongest signal for age-targeted products. */

    if (ctx.userDemos && product.tags) {

      var prodDemos = getTagsByPrefix(product.tags, 'demo:');

      var ageGroups = ['kids', 'teen', 'young-adult', 'adult', 'senior'];

      var userTopAge = null; var userTopAgeScore = 0;

      ageGroups.forEach(function (ag) {

        if (ctx.userDemos[ag] && ctx.userDemos[ag] > userTopAgeScore) {

          userTopAge = ag; userTopAgeScore = ctx.userDemos[ag];

        }

      });

      if (userTopAge && userTopAgeScore > 3) {

        var ageIdx = ageGroups.indexOf(userTopAge);

        prodDemos.forEach(function (d) {

          var prodIdx = ageGroups.indexOf(d);

          if (prodIdx >= 0 && ageIdx >= 0) {

            var dist = Math.abs(prodIdx - ageIdx);

            if (dist === 0) s += 5;       /* exact age match */

            else if (dist === 1) s += 2;   /* adjacent age */

            else if (dist >= 3) s -= 4;    /* far age mismatch */

          }

        });

      }

    }



    return jitter(s);

  }



  /* Phase 1 scoring is applied as a WRAPPER around scoreProduct

     to keep the main function clean. Called from buildFeed/loadNextBatch. */

  function scoreWithPhase1(product, pr, ctx) {

    var s = scoreProduct(product, pr, ctx);



    /* 15. Cart retargeting: carted items get massive boost */

    s += getCartRetargetBoost(product.handle, pr);



    /* 16. UTM match: products matching ad campaign */

    s += getUTMBoost(product, ctx.utm);



    /* 17. Search match: products matching recent search queries */

    s += getSearchBoost(product, ctx.searches);



    /* 18. Time-of-day context */

    s += getTimeOfDayBoost(product);



    /* 19. Referrer hint (cold start only) */

    if (ctx.cl <= 1) {

      s += getReferrerBoost(product, ctx.referrer);

    }



    return s;

  }



  /* ══ DIVERSITY + EXPLORE + BANDS ══ */

  function diversityCap(ranked, limit) {

    var res = []; var tc = {}; var max = Math.ceil(limit * DIVERSITY_CAP);

    var used = new Set();



    /* Pass 1: strict cap */

    for (var i = 0; i < ranked.length && res.length < limit; i++) {

      var t = normKey((ranked[i].p || ranked[i]).type || '') || '__n__';

      tc[t] = (tc[t] || 0);

      if (tc[t] < max) { res.push(ranked[i]); tc[t]++; used.add(ranked[i]); }

    }



    /* Pass 2: raise cap by 50% to fill remaining slots */

    if (res.length < limit) {

      var max2 = max + Math.ceil(max * 0.5);

      for (var j = 0; j < ranked.length && res.length < limit; j++) {

        if (used.has(ranked[j])) continue;

        var t2 = normKey((ranked[j].p || ranked[j]).type || '') || '__n__';

        tc[t2] = (tc[t2] || 0);

        if (tc[t2] < max2) { res.push(ranked[j]); tc[t2]++; used.add(ranked[j]); }

      }

    }



    /* Pass 3: last resort, ignore cap */

    if (res.length < limit) {

      for (var k = 0; k < ranked.length && res.length < limit; k++) {

        if (!used.has(ranked[k])) { res.push(ranked[k]); used.add(ranked[k]); }

      }

    }

    return res;

  }



  function exploreExploit(scored, allFresh, pr, limit) {

    var er = getExploreRatio(pr);

    var exploitN = Math.ceil(limit * (1 - er)); var exploreN = limit - exploitN;

    var exploit = scored.slice(0, exploitN);

    var known = new Set(Object.keys(pr.types || {}));

    var used = new Set(exploit.map(function (i) { return normKey((i.p || i).handle || ''); }));

    var cands = allFresh.filter(function (p) { var h = normKey((p.p || p).handle || ''); var t = normKey((p.p || p).type || ''); return !used.has(h) && (!t || !known.has(t)); });

    return exploit.concat(shuffle(cands).slice(0, exploreN));

  }



  function scoreBands(items) {

    if (items.length < 2) return items;

    var maxS = 0; items.forEach(function (i) { if ((i.s || 0) > maxS) maxS = i.s; });

    if (maxS <= 0) return shuffle(items);

    var bands = { a: [], b: [], c: [], d: [] };

    items.forEach(function (i) { var r = (i.s || 0) / maxS; if (r > 0.8) bands.a.push(i); else if (r > 0.5) bands.b.push(i); else if (r > 0.25) bands.c.push(i); else bands.d.push(i); });

    return shuffle(bands.a).concat(shuffle(bands.b), shuffle(bands.c), shuffle(bands.d));

  }



  function selectSeeds(pr, count) {

    var entries = Object.values(pr.products || {}).filter(function (e) { return e && e.id; });

    if (!entries.length) return [];

    entries.forEach(function (e) { e._sw = (e.score || 1) * decay(e.lastSeen) * ((e.viewCount || 1) >= 2 ? 2.5 : 1); });

    entries.sort(function (a, b) { return (b._sw || 0) - (a._sw || 0); });

    return shuffle(entries.slice(0, Math.min(count * 2, entries.length))).slice(0, count);

  }



  function buildCtx(pr, sl) {

    return {

      sl: sl, mp: getMedianPrice(pr), cl: getColdStart(pr),

      userFamilies: getUserFamilies(pr), userClusters: getUserClusters(pr),

      userPersonas: getUserTagProfile(pr, 'persona:'),

      userIntents: getUserTagProfile(pr, 'intent:'),

      userDemos: getUserTagProfile(pr, 'demo:'),

      /* Phase 1 */

      utm: parseUTM(),

      referrer: parseReferrer(),

      searches: getRecentSearches()

    };

  }



  /* ══ API ══ */

  async function fetchProductsPage(page) {

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try { var r = await fetch(root + 'products.json?page=' + page + '&limit=24', { credentials: 'same-origin' }); if (!r.ok) return []; var d = await r.json(); return Array.isArray(d.products) ? d.products : []; } catch (_) { return []; }

  }



  async function fetchCardHTML(handle) {

    var c = sGet(sessionStorage, CARD_CACHE_PREFIX + handle);

    if (c && c.length > 20) return c;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try { var r = await fetch(root + 'products/' + handle + '?sections=' + CARD_SECTION, { credentials: 'same-origin' }); if (!r.ok) return ''; var d = await r.json(); var h = d[CARD_SECTION] || ''; if (h.length > 20) sSet(sessionStorage, CARD_CACHE_PREFIX + handle, h); return h; } catch (_) { return ''; }

  }



  function fallbackCard(p) {

    var img = ''; if (p.images && p.images.length) img = p.images[0].src || ''; else if (p.image && p.image.src) img = p.image.src; else if (p.featured_image) img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');

    var price = ''; if (p.variants && p.variants.length) { var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'; try { price = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(parseFloat(p.variants[0].price) || 0); } catch (_) { price = p.variants[0].price; } }

    var it = img ? '<img src="' + img + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">' : '';

    return '<div class="product-card"><a href="/products/' + (p.handle || '') + '" style="display:block;text-decoration:none;color:inherit;"><div style="aspect-ratio:4/5;overflow:hidden;border-radius:12px;background:rgba(127,127,127,.08);margin-bottom:10px;">' + it + '</div><h3 style="margin:0 0 4px;font-size:14px;line-height:1.35;">' + (p.title || '') + '</h3>' + (price ? '<div style="font-size:14px;">' + price + '</div>' : '') + '</a></div>';

  }



  async function fetchRecommendations(pid) {

    if (!pid) return []; var ck = RECO_CACHE_PREFIX + pid; var cr = sGet(sessionStorage, ck); var c = cr ? safeJSON(cr, null) : null;

    if (c && c.exp > now() && Array.isArray(c.p)) return c.p;

    try { var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; var r = await fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { credentials: 'same-origin' }); if (!r.ok) return []; var d = await r.json(); var prods = Array.isArray(d.products) ? d.products : []; sSet(sessionStorage, ck, JSON.stringify({ exp: now() + RECO_TTL_H * 3600000, p: prods })); return prods; } catch (_) { return []; }

  }



  function preResolveCurrent() {

    var ctx = window.__PERSONAL_FEED_CONTEXT__ || {};

    var p = ctx.product; if (!p || !p.id || !p.handle) return;

    var pr = loadProfile(); var k = normKey(p.handle);

    if (k && pr.products[k] && !pr.products[k].id) { pr.products[k].id = p.id; saveLater(); }

    sSet(sessionStorage, ID_CACHE_PREFIX + p.handle, String(p.id));

  }



  function normProd(raw) {

    var img = ''; if (raw.images && raw.images.length) img = raw.images[0].src || ''; else if (raw.image && raw.image.src) img = raw.image.src;

    var avail = false; var price = 0; var cmp = 0;

    if (raw.variants && raw.variants.length) { avail = raw.variants.some(function (v) { return v.available; }); price = parseFloat(raw.variants[0].price) || 0; cmp = parseFloat(raw.variants[0].compare_at_price) || 0; }

    return { id: raw.id, handle: raw.handle || '', title: raw.title || '', url: '/products/' + (raw.handle || ''), featured_image: img, tags: raw.tags || [], type: raw.product_type || '', available: avail, source_collections: [], price: price, compare_at_price: cmp, created_at: raw.created_at || null, category: '' };

  }



  /* ══ INFINITE SCROLL ══ */

  async function loadNextBatch(section) {

    var st = scrollState.get(section); if (!st || st.loading || st.exhausted) return;

    st.loading = true;



    /* FIX: Re-read profile from localStorage on each batch.

       User may have opened products in new tabs → profile updated there.

       Without this, feed loads stale data from RAM cache. */

    memoryProfile = null; _genderCache = null;

    var loader = section.querySelector('[data-personalized-feed-loader]');

    if (loader) loader.classList.add('personalized-feed__loader--active');



    var pr = loadProfile();

    var batchSize = Number(section.dataset.productsLimit || 10);

    var maxPages = Number(section.dataset.maxPages || 20);

    var health = poolHealth(st.totalProducts || 200, pr);

    var sl = softLevel(health);

    var ctx = buildCtx(pr, sl);

    var allNew = [];



    if (!st.catalogDone) {

      var raw = await fetchProductsPage(st.page); st.page++;

      if (!raw.length) st.catalogDone = true;

      else raw.forEach(function (r) { allNew.push(Object.assign(normProd(r), { _raw: r })); });

    }



    if (st.seeds.length > 0) {

      var si = st.seedCursor % st.seeds.length; st.seedCursor++;

      var seed = st.seeds[si];

      if (seed && seed.id) { (await fetchRecommendations(seed.id)).forEach(function (r) { allNew.push(Object.assign(normProd(r), { recommendation_source: true, _raw: r })); }); }

      if (st.catalogDone && st.seeds.length > 1) {

        var si2 = st.seedCursor % st.seeds.length; st.seedCursor++;

        var s2 = st.seeds[si2];

        if (s2 && s2.id && s2.id !== (seed && seed.id)) { (await fetchRecommendations(s2.id)).forEach(function (r) { allNew.push(Object.assign(normProd(r), { recommendation_source: true, _raw: r })); }); }

      }

    }



    var fresh = []; var seen = new Set();

    allNew.forEach(function (p) { var k = normKey(p.handle); if (!k || st.shownHandles.has(k) || seen.has(k) || p.available === false) return; if (!isAvailable(k, pr) && sl < 3) return; seen.add(k); fresh.push(p); });



    var scored = fresh.map(function (p) { return { p: p, s: scoreWithPhase1(p, pr, ctx) }; }).sort(function (a, b) { return b.s - a.s; });

    var banded = scoreBands(scored);

    var diverse = diversityCap(banded, batchSize);

    var final = exploreExploit(diverse, fresh.map(function (p) { return { p: p, s: 0 }; }), pr, batchSize).slice(0, batchSize);



    if (final.length > 0) {

      var grid = section.querySelector('[data-personalized-feed-grid]');

      if (grid) {

        var frag = document.createDocumentFragment();

        var handles = final.map(function (r) { return (r.p || r).handle; });

        var htmls = await Promise.allSettled(handles.map(function (h) { return fetchCardHTML(h); }));

        for (var i = 0; i < final.length; i++) {

          var html = (htmls[i] && htmls[i].status === 'fulfilled') ? htmls[i].value : '';

          var prod = final[i].p || final[i];

          if (!html || html.length < 20) html = fallbackCard(prod._raw || prod);

          var cell = document.createElement('div'); cell.className = 'personalized-feed__cell';

          cell.setAttribute('data-pf-handle', prod.handle); cell.innerHTML = html; frag.appendChild(cell);

          st.shownHandles.add(normKey(prod.handle));

        }

        grid.appendChild(frag); reinitSection(section);

        markImpressions(handles, st.totalShown || 0);

        st.totalShown = (st.totalShown || 0) + handles.length;

      }

    }



    st.batchCount++; st.loading = false;

    if (loader) loader.classList.remove('personalized-feed__loader--active');

    if (st.batchCount >= maxPages || (final.length === 0 && st.catalogDone)) st.exhausted = true;

    if (st.exhausted) {

      var end = section.querySelector('[data-personalized-feed-end]'); if (end) end.style.display = '';

      if (st._scrollHandler) { window.removeEventListener('scroll', st._scrollHandler); st._scrollHandler = null; }

    }

  }



  function setupScroll(section) {

    var sentinel = section.querySelector('[data-personalized-feed-sentinel]'); if (!sentinel) return;

    var st = scrollState.get(section); if (!st) return;

    var throttle = null;

    var onScroll = function () { if (throttle || st.loading || st.exhausted) return; throttle = setTimeout(function () { throttle = null; }, 100); if (sentinel.getBoundingClientRect().top < window.innerHeight + 1000) loadNextBatch(section); };

    window.addEventListener('scroll', onScroll, { passive: true });

    st._scrollHandler = onScroll; setTimeout(onScroll, 300);

  }



  /* ══ BUILD FEED ══ */

  async function buildFeed(section) {

    if (!section || section.dataset.personalizedFeedBuilt === 'pending') return;

    section.dataset.personalizedFeedBuilt = 'pending'; lastBuildTime = now();

    var grid = section.querySelector('[data-personalized-feed-grid]');

    var titleNode = section.querySelector('[data-personalized-feed-title]');

    var subtitleNode = section.querySelector('[data-personalized-feed-subtitle]');

    if (!grid) return;



    memoryProfile = null; _genderCache = null;

    var pr = loadProfile();

    var visibleLimit = Number(grid.dataset.visibleLimit || section.dataset.productsLimit || 10);

    var health = poolHealth(200, pr); var sl = softLevel(health);

    var ctx = buildCtx(pr, sl);

    var seeds = [];



    try {

      var fbCache = []; var fbNode = section.querySelector('[data-personalized-feed-fallback]');

      if (fbNode) fbCache = safeJSON(fbNode.textContent, []) || [];

      var allCells = Array.from(grid.querySelectorAll('.personalized-feed__cell'));



      if (allCells.length > 1) {

        var hasProfile = Object.keys(pr.products || {}).length > 0;

        var scored = allCells.map(function (cell) {

          var handle = normKey(cell.getAttribute('data-pf-handle') || '');

          var prod = { handle: handle, tags: [], type: '', source_collections: [], price: 0, compare_at_price: 0, category: '' };

          for (var i = 0; i < fbCache.length; i++) {

            if (normKey(fbCache[i].handle) === handle) {

              prod.tags = fbCache[i].tags || []; prod.type = fbCache[i].type || '';

              prod.source_collections = fbCache[i].source_collections || [];

              prod.price = fbCache[i].price || 0; prod.compare_at_price = fbCache[i].compare_at_price || 0;

              prod.category = fbCache[i].category || '';

              break;

            }

          }

          var avail = isAvailable(handle, pr) || sl >= 3;

          return { cell: cell, handle: handle, type: prod.type, p: prod, s: !avail ? -999 : (hasProfile ? scoreWithPhase1(prod, pr, ctx) : Math.random()), banned: !avail };

        });



        scored.sort(function (a, b) { return b.s - a.s; });

        var banded = scoreBands(scored.filter(function (x) { return !x.banned; }));

        var visible = diversityCap(banded, visibleLimit);

        var visibleSet = new Set(visible);

        visible.forEach(function (item) { grid.appendChild(item.cell); });

        scored.forEach(function (item) { if (!visibleSet.has(item)) grid.appendChild(item.cell); });

        visible.forEach(function (item) { item.cell.style.display = ''; item.cell.removeAttribute('data-pf-extra'); });

        scored.forEach(function (item) { if (!visibleSet.has(item)) { item.cell.style.display = 'none'; item.cell.setAttribute('data-pf-extra', ''); } });

      }



      seeds = selectSeeds(pr, 8);

      if (seeds.length > 0) {

        if (titleNode && section.dataset.filledTitle) titleNode.textContent = section.dataset.filledTitle;

        if (subtitleNode && section.dataset.filledSubtitle) subtitleNode.textContent = section.dataset.filledSubtitle;

      }

    } catch (err) { console.warn('[PF] Error:', err); }



    var shownHandles = new Set();

    grid.querySelectorAll('.personalized-feed__cell').forEach(function (cell) { var h = normKey(cell.getAttribute('data-pf-handle')); if (h) shownHandles.add(h); });



    scrollState.set(section, { page: 2, shownHandles: shownHandles, seeds: seeds || [], seedCursor: 0, batchCount: 0, loading: false, exhausted: false, catalogDone: false, totalProducts: 200, totalShown: visibleLimit });

    section.dataset.personalizedFeedBuilt = 'true'; lastBuildTime = now();



    var vh = []; grid.querySelectorAll('.personalized-feed__cell:not([data-pf-extra])').forEach(function (cell) { var h = cell.getAttribute('data-pf-handle'); if (h) vh.push(h); });

    if (vh.length) markImpressions(vh, 1);

    setupScroll(section);

  }



  function observeSections() {

    var secs = document.querySelectorAll('[data-personalized-feed]'); if (!secs.length) return;

    var first = secs[0];

    if (first && first.dataset.personalizedFeedBuilt !== 'pending' && first.dataset.personalizedFeedBuilt !== 'true') buildFeed(first);

    if (secs.length <= 1) return;

    if (!('IntersectionObserver' in window)) { for (var i = 1; i < secs.length; i++) buildFeed(secs[i]); return; }

    var obs = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (!e.isIntersecting) return; obs.unobserve(e.target); buildFeed(e.target); }); }, { rootMargin: '200px 0px' });

    for (var j = 1; j < secs.length; j++) obs.observe(secs[j]);

  }



  var lastBuildTime = 0;

  function resetAll() {

    if (now() - lastBuildTime < 3000) return;

    memoryProfile = null; _genderCache = null; renderedImpressions.clear();

    document.querySelectorAll('[data-personalized-feed]').forEach(function (s) {

      var st = scrollState.get(s); if (st && st._scrollHandler) { window.removeEventListener('scroll', st._scrollHandler); st._scrollHandler = null; }

      scrollState.delete(s); s.dataset.personalizedFeedBuilt = 'false';

      var end = s.querySelector('[data-personalized-feed-end]'); if (end) end.style.display = 'none';

    });

    observeSections();

  }



  /* ══ TRACKING ══ */



  /**

   * FIX: Complete signal flow:

   *

   * User clicks link in feed → trackClicks fires:

   *   - addSignal(weight=1) — mild affinity signal

   *   - NO statusClick (we don't know dwell yet)

   *

   * User arrives at product page → trackView fires:

   *   - endDwell() → returns {handle, ms} for PREVIOUS product

   *   - statusClick(PREVIOUS handle, dwell) — correct attribution!

   *   - addSignal(currentProduct, weight=4) — strong affinity signal

   *   - startDwell(currentHandle) — start timer for THIS page

   *

   * User leaves product page → beforeunload saves profile

   * Next page load → endDwell returns THIS product's dwell, applied correctly.

   */



  function trackView() {

    var ctx = window.__PERSONAL_FEED_CONTEXT__ || {};

    var p = ctx.product; if (!p || !p.handle) return;



    /* FIX: Apply dwell to the PREVIOUS product (the one user just left) */

    var prevDwell = endDwell();

    if (prevDwell && prevDwell.handle && prevDwell.ms > 0) {

      var pr = loadProfile();

      statusClick(prevDwell.handle, pr, prevDwell.ms);

      saveLater();

    }



    /* Record signal for THIS product */

    var sk = VIEW_SESSION_PREFIX + normKey(p.handle);

    if (sGet(sessionStorage, sk)) {

      /* Already viewed this session — just restart dwell timer */

      startDwell(p.handle);

      return;

    }



    /* FIX: statusClick for THIS product (no dwell yet — will be applied on leave) */

    var pr2 = loadProfile();

    statusClick(p.handle, pr2);

    saveLater();



    var cols = Array.isArray(p.collections) && p.collections.length ? p.collections : getCollCtx();

    addSignal(Object.assign({}, p, { collections: cols }), W_VIEW);

    saveNow();

    sSet(sessionStorage, sk, '1');



    /* Start dwell timer for THIS page */

    startDwell(p.handle);

  }



  function trackClicks() {

    document.addEventListener('click', function (e) {

      var link = e.target.closest('a[href*="/products/"]');

      if (!link || link.hasAttribute('data-no-personal-feed-track')) return;

      try {

        var url = new URL(link.href, location.origin);

        if (url.origin !== location.origin) return;

        var m = url.pathname.match(/^\/products\/([^/?#]+)/);

        if (m && m[1]) {

          /**

           * FIX: only addSignal with LOW weight. NO statusClick.

           * statusClick will happen in trackView when product page loads.

           * This prevents double-counting clicks.

           */

          addSignal({ handle: m[1], url: url.pathname, collections: getCollCtx() }, W_FEED_CLICK);

          saveNow();

        }

      } catch (_) {}

    }, { passive: true });

  }



  function trackATC() {

    function record() {

      var ctx = window.__PERSONAL_FEED_CONTEXT__ || {};

      if (ctx.product && ctx.product.handle) {

        var pr = loadProfile(); statusCart(ctx.product.handle, pr); saveLater();

        addSignal(Object.assign({}, ctx.product, { collections: getCollCtx() }), W_ATC);

        saveNow();

      }

    }

    document.addEventListener('product-ajax:added', record);

    document.addEventListener('cart:add', record);

    document.addEventListener('submit', function (e) { if (!(e.target instanceof HTMLFormElement)) return; if ((e.target.getAttribute('action') || '').indexOf('/cart/add') === -1) return; record(); }, true);

    if (typeof window.fetch === 'function') {

      var orig = window.fetch;

      window.fetch = function () { var u = arguments[0]; var s = typeof u === 'string' ? u : (u && u.url) || ''; if (s.indexOf('/cart/add') !== -1) { try { record(); } catch (_) {} } return orig.apply(this, arguments); };

    }

  }



  /* ══ BOOT ══ */

  function boot() {

    /* Phase 1: Parse entry signals before anything else */

    parseUTM(); parseReferrer(); trackSearch();



    trackView(); preResolveCurrent(); trackClicks(); trackATC();

    requestAnimationFrame(function () { setTimeout(observeSections, 50); });

    document.addEventListener('shopify:section:load', function (e) {

      if (isOurReinit) return; var t = e.target; if (!t) return;

      var s = t.matches('[data-personalized-feed]') ? t : t.querySelector('[data-personalized-feed]');

      if (s) { s.dataset.personalizedFeedBuilt = 'false'; buildFeed(s); }

    });

    document.addEventListener('page:loaded', resetAll);

    document.addEventListener('turbolinks:load', resetAll);

    document.addEventListener('turbo:load', resetAll);

    window.addEventListener('pageshow', function (e) { if (e.persisted) resetAll(); });

    window.addEventListener('beforeunload', saveNow);



    window.__pf_reset = function () {

      memoryProfile = null; _genderCache = null; clearTimeout(saveTimer);

      try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}

      try { var keys = []; for (var i = 0; i < sessionStorage.length; i++) { var k = sessionStorage.key(i); if (k && k.indexOf('hyper_') === 0) keys.push(k); } keys.forEach(function (k) { sessionStorage.removeItem(k); }); } catch (_) {}

      window.removeEventListener('beforeunload', saveNow);

      window.location.href = window.location.pathname + '?reset=' + Date.now();

    };

    ['mousedown', 'touchstart'].forEach(function (evt) {

      document.addEventListener(evt, function (e) {

        var el = e.target;

        if ((el.hasAttribute && el.hasAttribute('data-personalized-feed-reset')) || (el.closest && el.closest('[data-personalized-feed-reset]'))) {

          e.preventDefault(); e.stopImmediatePropagation(); window.__pf_reset();

        }

      }, true);

    });

  }



  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });

  else boot();

})();